class documentsListService {
  constructor ($q, $http, ngAuthSettings, $httpParamSerializerJQLike) {
    this.$q = $q;
    this.$http = $http;
    this.ngAuthSettings = ngAuthSettings;
    this.$httpParamSerializerJQLike= $httpParamSerializerJQLike;
  }
  
  getActivitiesData(data) {
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'POST',
        url: this.ngAuthSettings.apiServiceBaseUri + '/opalo/opalo/consulta',
        data: this.$httpParamSerializerJQLike(data),
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        cache : false
      }).then(function (response) {
        resolve(response.data);
      }, function (reason) {
        reject(reason);
      });
    });
  }
  
  exportarXls(data) {
	 return this.$q((resolve, reject) => {
      this.$http({
        method: 'POST',
        url: this.ngAuthSettings.apiServiceBaseUri + '/opalo/opalo/exportar-datos-csv',
        data: this.$httpParamSerializerJQLike(data),
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        cache : false
      }).then(function (response) {
        resolve(response.data);
      }, function (reason) {
        reject(reason);
      });
    });
  }
  
  descargarDocumento(data) {
	 return this.$q((resolve, reject) => {
      this.$http({
        method: 'POST',
        url: this.ngAuthSettings.apiServiceBaseUri + '/opalo/opalo/descarga-documento',
        data: this.$httpParamSerializerJQLike(data),
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        cache : false
      }).then(function (response) {
        resolve(response.data);
      }, function (reason) {
        reject(reason);
      });
    });
  }
}

documentsListService.$inject = ['$q','$http', 'ngAuthSettings', '$httpParamSerializerJQLike'];

export default documentsListService;


/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/consult-crm/documents-list/documents-list.service.js
 **/